import './about.scss';

function About() {
  return (
    <main className="main">
      <h1 className="about__title">О проекте</h1>
    </main>
  );
}

export default About;
